import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm, Controller } from 'react-hook-form';

import { Button, Box, WrappedTextInput } from 'components';
import { handleForgotPassword } from 'redux-modules/auth/Actions';
import { RootState } from 'redux-modules/store/rootState';
import { ForgotPasswordSchema } from 'common/utils/validations';
import { Logo } from 'assets';
import history from 'common/utils/history';

import styles from './styles';
import SignInImage from '../SignInImage';

type ForgotPasswordType = {
  username: string;
};

// Called when click on forgot password
const ForgotPassword = () => {
  const dispatch = useDispatch();
  const classes = styles();

  const { errorMessage, isLoading } = useSelector(
    ({ Auth }: RootState) => Auth.forgotPassword,
  );

  const { handleSubmit, control } = useForm({
    mode: 'onChange',
    resolver: yupResolver(ForgotPasswordSchema),
  });

  const onSubmit = ({ username }: ForgotPasswordType) => {
    dispatch(handleForgotPassword({ username }));
  };

  return (
    <>
      <Box className={classes.gridContainer}>
        <Box className={classes.leftSide}>
          <Box className={classes.leftSideContent}>
            <Box className={classes.imgBox}>
              <img src={Logo} alt={Logo} className={classes.logoIcon} />
            </Box>
            <Typography
              variant="h2"
              gutterBottom
              className={classes.welcome8vdx}
            >
              Forgot Password
            </Typography>
            <Typography className={classes.welcomeSub8vdx}>
              Enter your email and we’ll send a link on your email to reset your
              password.
            </Typography>
            <form
              onSubmit={handleSubmit(onSubmit)}
              data-testid="forgotPasswordForm"
              className={classes.validateForm}
            >
              <Typography className={classes.labelText} variant="body1">
                Email *
              </Typography>
              <Controller
                name="username"
                control={control}
                defaultValue=""
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <Box className={classes.controllerBox}>
                    <WrappedTextInput
                      type="text"
                      // label="Email"
                      placeholder="Email"
                      className={classes.textValInput}
                      InputProps={{ classes: { root: classes.inputRoot } }}
                      InputLabelProps={{
                        classes: {
                          root: classes.labelRoot,
                          focused: classes.labelFocused,
                        },
                      }}
                      value={value}
                      onChange={onChange}
                      error={error?.message ? true : false}
                    />
                    {error?.message && (
                      <span className={classes.errorText}>
                        {error?.message}
                      </span>
                    )}
                  </Box>
                )}
                rules={{ required: 'Email is required' }}
              />
              <Box>
                {errorMessage && (
                  <Typography
                    variant="body1"
                    gutterBottom
                    className={classes.errorAlready}
                  >
                    {errorMessage}
                  </Typography>
                )}
                <Button
                  name="Confirm"
                  type="submit"
                  className={classes.signupBtn}
                  isLoading={isLoading}
                  disabled={isLoading}
                />
              </Box>
            </form>
            <Box>
              <Typography className={classes.alreadyAcText}>
                Already have an account ?
                <a
                  onClick={() => history.push('/sign-in')}
                  rel="noreferrer"
                  className={classes.signInLink}
                >
                  {' '}
                  Back to login
                </a>
              </Typography>
              <Typography className={classes.copyText}>
                © 2022 8vdX All rights reserved .
              </Typography>
            </Box>
          </Box>
        </Box>
        <SignInImage />
      </Box>
    </>
  );
};

export default ForgotPassword;
